import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function HotComicsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h3>
            <p className="text-sm text-foreground-600 mt-2">大家都在看的精彩漫画</p>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}